// src/config.js

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.arammarketing.com/api/v1/public';
// const BACKEND_URL = 'https://api.arammarketing.com/api/v1';

export default BACKEND_URL;
